/*
 * Campaign /52 API — REAL endpoints (mocks retired Sep 8, 2026).
 * Base: `process.env.REACT_APP_BACKEND_URL` (CRA app - NOT Vite/import.meta).
 * Contract (KGOB_COM_52_PENDING_BUILD_HANDOFF.md §4, return shapes unchanged):
 *   POST {REACT_APP_BACKEND_URL}/api/52/verify/send   { email, website? }        -> { ok, expires_in|error }
 *   POST {REACT_APP_BACKEND_URL}/api/52/verify/check  { email, code }            -> { ok, error? }
 *   POST {REACT_APP_BACKEND_URL}/api/52/lead          { ...§4-A doc, website? }  -> { ok, error? }
 *   POST {REACT_APP_BACKEND_URL}/api/52/path          { kgob_campaign_lead_id, vid, path_chosen } -> { ok }
 * reportPath uses navigator.sendBeacon (keepalive fetch fallback) per §4.4 so the
 * update survives the outbound navigation. Codes are hashed server-side, never here.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;

async function post(path, payload) {
  try {
    const res = await fetch(`${BASE}/api/52/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return await res.json();
  } catch {
    return { ok: false, error: 'network' };
  }
}

export function sendCode(email, website = '') {
  return post('verify/send', { email, website });
}

export function checkCode(email, code) {
  return post('verify/check', { email, code });
}

export function submitLead(doc) {
  return post('lead', doc);
}

export function reportPath({ kgob_campaign_lead_id, vid, path_chosen }) {
  const payload = JSON.stringify({ kgob_campaign_lead_id, vid, path_chosen });
  try {
    if (navigator.sendBeacon) {
      const sent = navigator.sendBeacon(`${BASE}/api/52/path`, new Blob([payload], { type: 'application/json' }));
      if (sent) return Promise.resolve({ ok: true });
    }
  } catch { /* no action needed */ }
  try {
    return fetch(`${BASE}/api/52/path`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: payload, keepalive: true,
    }).then((r) => r.json()).catch(() => ({ ok: false }));
  } catch {
    return Promise.resolve({ ok: false });
  }
}
